import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Label, Input, Form, FormGroup, Col, Button } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loading } from "../share/loading";
import { FaSistrix } from "react-icons/fa";
import { BsDownload } from "react-icons/bs";
import "../share/form.css";

export function AdminCheckComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  console.log(user);
  // let userApprove = user.
  const [loading, setLoading] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const [remarkPromotionValue, setRemarkPromotionValue] = useState("");
  // const [data, setData] = useState([]);
  const [dataRegister, setDataRegister] = useState({});

  const styled = {
    backgroundColor: "rgba(250, 237, 161, 0.3)",
    border: "1px solid rgba(250, 200, 100)"
  }
  // const openInNewTab = (url) => {
  //   const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  //   if (newWindow) newWindow.opener = null
  // }
  // function onClickUrl(url) {
  //   return () => openInNewTab(url)
  // }


  useEffect(() => {
    async function getDataRegister() {
      setLoading(true)
      let postData = new FormData();
      postData.append("borrowId", searchParams.get("req"))
      try {
        let res = await fetch("/api/BorrowRegis/considerBorrowing", {
          method: "POST",
          body: postData,
        });
        let resJson = await res.json();
        setDataRegister(resJson.dataenum);
        // console.log("resJson =>", resJson)

      } catch (e) {
        console.log("err => ", e)
      } finally {
        setLoading(false);
      }
    }
    getDataRegister();
  }, []);

  const formPromotionInitialValues = {
    remarkPromotion: remarkPromotionValue,
    borrowStatus: "12",
    borrowId: searchParams.get("req"),

  };

  const formInitialValues = {
    remarkOfficer: remarkValue,
    borrowStatus: "8",
    borrowId: searchParams.get("req"),
    userApprove: user.fullName,
    file1: "",
    file2: "",
    file3: ""
  };

  const validateSchema = Yup.object().shape({});

  const validatePromotionSchema = Yup.object().shape({});

  const onSubmit = async (values) => {

    // console.log('value', values)
    if (values.borrowStatus === "8") {
      setFieldValue("remarkOfficer", "");
    }

    // console.log(values);
    let postData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      postData.append(key, value);
    });

    postData.append("deptId", user.deptId);
    try {
      let res = await fetch("api/Borrow/approveOrRejectOfficer", {
        method: "POST",
        body: postData,
      });
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/borrowing/`);
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const promotionSubmit = async (values) => {
    console.log(values);
    if (values.borrowStatus === "12") {
      setFieldValue("remarkPromotion", "");
    }

    console.log(values);
    let postData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      postData.append(key, value);
    });

    try {
      let res = await fetch("api/Borrow/approveOrRejectPromotion", {
        method: "POST",
        body: postData,
      });
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/borrowing/`);
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const { setFieldValue, handleSubmit, handleBlur, touched, errors } = useFormik({
    initialValues: formInitialValues,
    validationSchema: validateSchema,
    onSubmit,
  });

  const promotionFormik = useFormik({
    initialValues: formPromotionInitialValues,
    validationSchema: validatePromotionSchema,
    onSubmit: promotionSubmit,
  });

  function rejectButtonClick() {
    Swal.fire({
      title: "",
      text: "กรุณากรอกความคิดเห็น",
      confirmButtonColor: "#0A66C2",
      confirmButtonText: "ตกลง",
      input: "text",
      inputValue: remarkValue,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      cancelButtonColor: "#ff0000",
      inputValidator: (value) => {
        if (!value) {
          return "กรุณากรอกความคิดเห็น";
        }
      },
    }).then((result) => {
      if (result.value) {
        // setRemarkValue(result.value);
        setFieldValue("remarkOfficer", result.value);
        setFieldValue("borrowStatus", "7");
        handleSubmit();
      }
    });
  }

  function rejectButtonPromotionClick() {
    Swal.fire({
      title: "",
      text: "กรุณากรอกความคิดเห็น",
      confirmButtonColor: "#0A66C2",
      confirmButtonText: "ตกลง",
      input: "text",
      inputValue: remarkPromotionValue,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      cancelButtonColor: "#ff0000",
      inputValidator: (value) => {
        if (!value) {
          return "กรุณากรอกความคิดเห็น";
        }
      },
    }).then((result) => {
      if (result.value) {
        // setRemarkValue(result.value);
        promotionFormik.setFieldValue("remarkPromotion", result.value);
        promotionFormik.setFieldValue("borrowStatus", "11");
        promotionFormik.handleSubmit();
      }
    });
  }

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center">
      <p
        className="text-center py-2 text-white"
        style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "960px" }}
      >
        ข้อมูลคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
      </p>
      {/* รายละเอียดย่อย */}
      <div className="form-border">
        {!loading ? (
          <div className="px-5 my-5">
            <FormGroup row>
              <Label
                for="วันที่ขอกู้"
                sm={2}
              >
                วันที่ขอกู้
              </Label>
              <Col sm={4}>
                <Input
                  value={dataRegister.createDate}
                  className="rounded-pill text-center input-color"
                  style={styled}
                  disabled
                />
              </Col>
              <Label
                for="ชื่อผู้ขอกู้ยืมเงิน"
                sm={2}
              >
                ชื่อผู้ขอกู้ยืมเงิน
              </Label>
              <Col sm={4}>
                <Input
                  value={dataRegister.employee}
                  className="rounded-pill text-center input-color"
                  style={styled}
                  disabled
                />
              </Col>
            </FormGroup>
            <div className="d-flex justify-content-center">
              <button
                sm={12}
                className="btn-blue rounded-pill mt-3"
                onClick={() => { navigate(`/borrowing/admin/check/detail?id=${searchParams.get("req")}`); }}
              >
                ดูรายละเอียดคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพิ่มเติม
                <FaSistrix className="mx-2 style-icon" />
              </button>
            </div>

          </div>
        ) : (
          <Loading />
        )}
      </div>



      <p
        className="text-center py-2 text-white mt-3"
        style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "960px" }}
      >
        {user.roldId === "3" ? "แนบเอกสารเพิ่มเติมสำหรับเจ้าหน้าที่" : "เอกสารเพิ่มเติมของเจ้าหน้าที่ สพร./สนพ."}
      </p>

      <div className="form-border">
        {user.roldId === "3" ? (
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(e);
            }}
            className="d-flex flex-column justify-content-center p-5"
          >

            <FormGroup row>
              <Label sm={8}>
                สำเนาบัตรประชาชนของผู้กู้ยืม/หุ้นส่วนผู้มีอำนาจลงนาม
              </Label>
              <Col sm={4}>
                <Input
                  className={touched.file1 && errors.file1 ?
                    "input-error rounded-pill text-center input-color " : "rounded-pill text-center input-color "
                  }
                  onBlur={handleBlur}
                  onChange={(e) => {
                    // handleChange(e)
                    if (e.target && e.target.files[0]) {
                      setFieldValue("file1", e.target.files[0])
                    }
                  }}
                  type="file"
                  name="file1"
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label sm={8}>
                หนังสือรับรองการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์(ไม่เกิน
                3เดือนในวันที่ยื่นคำขอกู้)
              </Label>
              <Col sm={4}>
                <Input
                  className={touched.file2 && errors.file2 ?
                    "input-error rounded-pill text-center input-color " : "rounded-pill text-center input-color "
                  }
                  onBlur={handleBlur}
                  onChange={(e) => {
                    // handleChange(e)
                    if (e.target && e.target.files[0]) {
                      setFieldValue("file2", e.target.files[0])
                    }
                  }}
                  type="file"
                  name="file2"
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label sm={8}>
                สำเนาใบอนุญาตดำเนินการทดสอบมาตรฐานฝีมือแรงงาน(เฉพาะผู้ดำเนินการทดสอบ)
              </Label>
              <Col sm={4}>
                <Input
                  className={touched.file3 && errors.file3 ?
                    "input-error rounded-pill text-center input-color " : "rounded-pill text-center input-color "
                  }
                  onBlur={handleBlur}
                  onChange={(e) => {
                    // handleChange(e)
                    if (e.target && e.target.files[0]) {
                      setFieldValue("file3", e.target.files[0])
                    }
                  }}
                  type="file"
                  name="file3"
                />
              </Col>
            </FormGroup>


            <hr />
            <FormGroup row>
              <Col sm={6} className="text-center mt-2">
                <button type="submit" className="btn-green w-50">
                  ผ่าน
                </button>
              </Col>
              <Col sm={6} className="text-center mt-2">
                <button
                  type="button"
                  onClick={rejectButtonClick}
                  className="btn-red w-50"
                >
                  ไม่ผ่าน ส่งแก้ไข
                </button>
              </Col>
            </FormGroup>

          </Form>
        ) : (
          <div className="d-flex flex-column pt-5 px-5">
            {dataRegister?.fOfficerRegisterPath === null && dataRegister?.fOfficerLicenseTestPath === null && dataRegister?.fOfficerIdCardPath === null ? (
              <span className="text-center">ไม่พบเอกสารเพิ่มเติมของเจ้าหน้าที่ สพร./ สนพ.</span>
            ) : null}
            {dataRegister?.fOfficerIdCardPath != null ? (
              <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                <span className="px-3">สำเนาบัตรประชาชนของผู้กู้ยืม/หุ้นส่วนผู้มีอำนาจลงนาม</span>
                <Button
                  href={dataRegister?.fOfficerIdCardPath}
                  className="download-btn me-3 rounded-pill"
                  download
                >
                  <BsDownload className="me-2" />
                  ดาวน์โหลด
                </Button>
              </FormGroup>
            ) : null}

            {dataRegister?.fOfficerRegisterPath != null ? (
              <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                <span className="px-3">หนังสือรับรองการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์(ไม่เกิน 3 เดือนในวันที่ยื่นคำขอกู้)</span>
                <Button
                  href={dataRegister?.fOfficerRegisterPath}
                  className="download-btn me-3 rounded-pill"
                  download
                >
                  <BsDownload className="me-2" />
                  ดาวน์โหลด
                </Button>
              </FormGroup>
            ) : null}

            {dataRegister?.fOfficerLicenseTestPath != null ? (
              <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                <span className="px-3">สำเนาใบอนุญาตดำเนินการทดสอบมาตรฐานฝีมือแรงงาน(เฉพาะผู้ดำเนินการทดสอบ)</span>
                <Button
                  href={dataRegister?.fOfficerLicenseTestPath}
                  className="download-btn me-3 rounded-pill"
                  download
                >
                  <BsDownload className="me-2" />
                  ดาวน์โหลด
                </Button>
              </FormGroup>
            ) : null}

            <Form
              onSubmit={(e) => {
                e.preventDefault();
                promotionFormik.handleSubmit(e);
              }}
            >
              <hr />
              <FormGroup row>
                <Col sm={6} className="text-center mt-2">
                  <button type="submit" className="btn-green w-50">
                    เห็นชอบ
                  </button>
                </Col>
                <Col sm={6} className="text-center mt-2">
                  <button
                    type="button"
                    onClick={rejectButtonPromotionClick}
                    className="btn-red w-50"
                  >
                    ไม่เห็นชอบ
                  </button>
                </Col>
              </FormGroup>

            </Form>
          </div>
        )}
        <div className="d-flex justify-content-center align-items-center w-100 mb-4">
          <Button
            type="button"
            onClick={() => { navigate(`/borrowing/`); }}
            className="btn-blue p-2 w-25"
          >ย้อนกลับ
          </Button>
        </div>



      </div>
    </Container>
  );
}
